import { render } from "./Expired.vue?vue&type=template&id=4f50a59b"
import script from "./Expired.vue?vue&type=script&lang=js"
export * from "./Expired.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Dashboard/Type/Expired.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f50a59b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f50a59b', __exports__)) {
    api.reload('4f50a59b', __exports__)
  }
  
  module.hot.accept("./Expired.vue?vue&type=template&id=4f50a59b", () => {
    api.rerender('4f50a59b', render)
  })

}


export default __exports__